import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

console.log('API_URL configuration:', API_URL);
console.log('REACT_APP_BACKEND_URL:', process.env.REACT_APP_BACKEND_URL);

export const api = axios.create({
  baseURL: API_URL,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Courses
export const getCourses = (status) => api.get('/courses/', { params: { status } });
export const getCourse = (id) => api.get(`/courses/${id}`);
export const createCourse = (data) => api.post('/courses/', data);
export const updateCourse = (id, data) => api.put(`/courses/${id}`, data);
export const deleteCourse = (id) => api.delete(`/courses/${id}`);

// Modules
export const getModules = (courseId) => api.get(`/courses/${courseId}/modules`);
export const createModule = (courseId, data) => api.post(`/courses/${courseId}/modules`, data);
export const updateModule = (courseId, moduleId, data) => api.put(`/courses/${courseId}/modules/${moduleId}`, data);
export const deleteModule = (courseId, moduleId) => api.delete(`/courses/${courseId}/modules/${moduleId}`);

// Lessons
export const getLessons = (courseId, moduleId) => api.get(`/courses/${courseId}/modules/${moduleId}/lessons`);
export const createLesson = (courseId, moduleId, data) => api.post(`/courses/${courseId}/modules/${moduleId}/lessons`, data);
export const updateLesson = (courseId, moduleId, lessonId, data) => api.put(`/courses/${courseId}/modules/${moduleId}/lessons/${lessonId}`, data);
export const deleteLesson = (courseId, moduleId, lessonId) => api.delete(`/courses/${courseId}/modules/${moduleId}/lessons/${lessonId}`);

// Enrollments
export const getEnrollments = (params) => api.get('/enrollments/', { params });
export const createEnrollment = (data) => api.post('/enrollments/', data);
export const updateProgress = (enrollmentId, progress) => api.put(`/enrollments/${enrollmentId}/progress`, null, { params: { progress } });

// Certificates
export const getCertificates = (userId) => api.get('/certificates/', { params: { user_id: userId } });
export const createCertificate = (data) => api.post('/certificates/', data);
export const updateCertificate = (id, data) => api.put(`/certificates/${id}`, data);
export const revokeCertificate = (id, reason) => api.put(`/certificates/${id}/revoke`, null, { params: { reason } });
export const verifyCertificate = (code) => api.get(`/certificates/verify/${code}`);
export const downloadCertificate = (certId, params = {}) => {
  const filtered = Object.fromEntries(Object.entries(params).filter(([, v]) => v != null && v !== ''));
  const qs = new URLSearchParams(filtered).toString();
  return `${API_URL}/certificates/download/${certId}${qs ? '?' + qs : ''}`;
};

// External Certificates
export const getExternalCertificates = () => api.get('/certificates/external/');
export const getExternalCertificate = (id) => api.get(`/certificates/external/${id}`);
export const createExternalCertificate = (formData) => api.post('/certificates/external/', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const updateExternalCertificate = (id, formData) => api.put(`/certificates/external/${id}`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const deleteExternalCertificate = (id) => api.delete(`/certificates/external/${id}`);
export const downloadExternalCertificate = (id) => `${API_URL}/certificates/external/${id}/download`;

// Reviews
export const getCertificateReviews = (certId) => api.get(`/reviews/certificate/${certId}`);
export const createReview = (data) => api.post('/reviews', data);
export const getPendingReviews = () => api.get('/reviews/pending');
export const moderateReview = (reviewId, status) => api.put(`/reviews/${reviewId}/moderate`, null, { params: { new_status: status } });

// Users
export const getUsers = () => api.get('/users/');
export const createUser = (data) => api.post('/users/', data);
export const updateUser = (id, data) => api.put(`/users/${id}`, data);
export const deleteUser = (id) => api.delete(`/users/${id}`);

// Legacy Certificates
export const searchLegacyCertificates = (q, page = 1, limit = 20, folioOnly = false) =>
  api.get('/certificates/legacy/search', { params: { q, page, limit, folio_only: folioOnly } });
export const importLegacyCertificates = () => api.post('/certificates/legacy/import');
export const getLegacyImportStatus = () => api.get('/certificates/legacy/import/status');
export const getLegacyStats = () => api.get('/certificates/legacy/stats');
export const deleteAllLegacy = () => api.delete('/certificates/legacy/all');

// AI Chat
export const chatWithAI = (message, courseId) => api.post('/ai/chat', { message, course_id: courseId });
export const createKnowledge = (data) => api.post('/ai/knowledge', data);
export const getKnowledge = () => api.get('/ai/knowledge');
export const deleteKnowledge = (id) => api.delete(`/ai/knowledge/${id}`);

// LMS
export const getCourseContent = (courseId) => api.get(`/lms/course-content/${courseId}`);
export const completeLesson = (data) => api.post('/lms/complete-lesson', data);
export const submitQuiz = (data) => api.post('/lms/submit-quiz', data);
export const getMyCert = (courseId) => api.get(`/lms/my-cert/${courseId}`);

// Course images
export const uploadCourseImage = (courseId, formData) => api.post(`/courses/${courseId}/upload-image`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const uploadContentImage = (formData) => api.post('/courses/upload-image', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});

// Enrollment requests
export const submitEnrollmentRequest = (formData) => api.post('/enrollments/request', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const getEnrollmentRequests = (params) => api.get('/enrollments/requests', { params });
export const updateRequestStatus = (reqId, status) => api.put(`/enrollments/requests/${reqId}/status`, { status });
export const exportEnrollmentRequestsCsv = (params) => api.get('/enrollments/requests/export', {
  params, responseType: 'blob',
});

// Articles
export const getPublicArticles = (limit = 50) => api.get('/articles/', { params: { limit } });
export const getArticlesByCourse = (courseId, limit = 6) => api.get(`/articles/by-course/${courseId}`, { params: { limit } });
export const getArticleBySlug = (slug) => api.get(`/articles/by-slug/${slug}`);
export const listArticlesAdmin = () => api.get('/articles/admin/list');
export const createArticle = (data) => api.post('/articles/', data);
export const updateArticle = (id, data) => api.put(`/articles/${id}`, data);
export const deleteArticle = (id) => api.delete(`/articles/${id}`);
export const uploadArticleImage = (formData) => api.post('/articles/upload-image', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});

// Country contacts
export const getCountryContacts = () => api.get('/country-contacts/');
export const createCountryContact = (data) => api.post('/country-contacts/', data);
export const updateCountryContact = (id, data) => api.put(`/country-contacts/${id}`, data);
export const deleteCountryContact = (id) => api.delete(`/country-contacts/${id}`);
export const uploadContactAvatar = (formData) => api.post('/country-contacts/upload-avatar', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});

// User profile (self)
export const getMyProfile = () => api.get('/users/me');
export const updateMyProfile = (data) => api.put('/users/me', data);
export const changeMyPassword = (data) => api.put('/users/me/password', data);
export const uploadMyAvatar = (formData) => api.post('/users/me/avatar', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});

// Dashboard metrics
export const getProfessorMetrics = () => api.get('/dashboard/professor-metrics');

// Certificate ratings (public, works for course/external/legacy)
export const getCertificateRatings = (code) => api.get(`/certificate-ratings/${encodeURIComponent(code)}`);
export const getCertificateRatingsSummary = (code) => api.get(`/certificate-ratings/${encodeURIComponent(code)}/summary`);
export const submitCertificateRating = (data) => api.post('/certificate-ratings/', data);
export const deleteCertificateRating = (id) => api.delete(`/certificate-ratings/${id}`);

// Certificate assignment to registered users
export const searchUsers = (q) => api.get(`/cert-assign/users/search?q=${encodeURIComponent(q || '')}`);
export const assignExternalCertToUser = (certId, userId) => api.put(`/cert-assign/external/${certId}/assign-user`, { user_id: userId });
export const unassignExternalCert = (certId) => api.delete(`/cert-assign/external/${certId}/unassign-user`);
export const assignLegacyCertToUser = (certId, userId) => api.put(`/cert-assign/legacy/${certId}/assign-user`, { user_id: userId });
export const unassignLegacyCert = (certId) => api.delete(`/cert-assign/legacy/${certId}/unassign-user`);
export const getMyAssignedCertificates = () => api.get('/cert-assign/me/certificates');
export const claimMyCertificates = () => api.post('/cert-assign/me/claim');

export default api;
